import {createElement, PropTypes} from 'rlink-react';

export default function ShopItemFootnote ({css, footnote}) {
  if (footnote !== '') {
    return <div className={css.Footnote}>{footnote}</div>;
  }
  return null;
}

ShopItemFootnote.propTypes = {
  css: PropTypes.object,
  footnote: PropTypes.string,
};

ShopItemFootnote.defaultProps = {
  footnote: '',
};



// WEBPACK FOOTER //
// ./lib/rlink-shop/components/ShopItemFootnote.jsx